// src/utils/getItemDetails.js
// 共用：取得商品詳細規格字串，供 Calculator 與 History 共享
import { LOGO_PROCESSING_OPTIONS, SOFA_AREA_TYPES } from "../data";

const getItemDetails = (item, productType) => {
  let details = [];

  if (productType === "apron") {
    if (item.selectedLogos && Object.keys(item.selectedLogos).length > 0) {
      let logos = [];
      Object.entries(item.selectedLogos).forEach(([k, v]) => {
        if (v > 0) {
          const opt = LOGO_PROCESSING_OPTIONS.find((o) => o.value === k);
          const label = opt?.label.split("(")[0];
          const cost = opt?.cost;
          logos.push(`${label}$${cost}x${v}`);
        }
      });
      if (logos.length > 0) details.push(`LOGO:${logos.join(",")}`);
    }

    if (item.hasModification) details.push("修改");
    if (item.hasStrapChange) details.push("改背帶");

    if (item.details?.plateFee > 0) {
      const countStr = item.details.plateFeeCount
        ? `x${item.details.plateFeeCount}`
        : "";
      details.push(`版費$${item.details.plateFee}${countStr}`);
    }
    if (item.details?.machineFee > 0)
      details.push(`上機費$${item.details.machineFee}`);

    return details.join(", ");
  }

  if (productType === "cushion") {
    const showThickness = !item.cushionType.includes("抱枕");
    if (showThickness) {
      let denseStr = !item.cushionType.includes("單布套") ? item.density : "";
      if (denseStr || item.thickness) {
        details.push(
          `${denseStr}${item.thickness ? `(厚${item.thickness}cm)` : ""}`
        );
      }
    }
    let opts = [];
    if (
      item.cushionOption &&
      item.cushionOption !== "A" &&
      item.cushionType.includes("靠墊")
    )
      opts.push(`${item.cushionOption}款`);
    if (item.isIrregular) opts.push("異形");
    if (item.isRounded) opts.push("圓角");
    if (item.isDoubleSided) opts.push("雙面");
    if (item.hasStraps) opts.push(`綁帶x${item.strapCount}`);
    if (opts.length > 0) details.push(`[${opts.join("、")}]`);
  }

  if (productType === "wall_sticker") {
    details.push(
      `[${item.wsThickness}cm${
        item.wsFireType === "fire" ? "/耐燃" : "/密集板"
      }]`
    );
  }

  if (productType === "dust_mite") {
    if (item.hasCuttingFee) details.push("[裁切]");
    if (item.hasPlateFee) details.push("[版費]");
  }

  if (productType === "sofa_mat") {
    const areaType = item.sofaArea || "free";
    const areaLabel = SOFA_AREA_TYPES.find((a) => a.value === areaType)?.label;
    if (areaLabel) details.push(`[${areaLabel}]`);
    if (item.sofaMakeSize && areaType !== "free")
      details.push(
        `建議製作 寬${item.sofaMakeSize.width} x 深${item.sofaMakeSize.depth}CM`
      );
  }

  if (productType === "carpet" || productType === "edging_carpet") {
    if (item.plateFee > 0) details.push("[排版費]");
  }

  return details.join(" ");
};

export default getItemDetails;
